import React from "react"
import hoppBowtie from "@images/icons/hoppBowtie.svg"
import hoppO from "@images/icons/hoppO.svg"
import * as styles from "./OnboardingSpinner.module.scss"

const OnboardingSpinner = (props) =>
  props.active ? (
    <div className={`${styles.OnboardingSpinner} ${props.lowOpacity && styles.lowOpacity}`}>
      <div className={styles.inner}>
        <div className={styles.image}>
          <img src={hoppO} alt="" />
          <img className={styles.bowtie} src={hoppBowtie} alt="" />
        </div>
        {props.message && <h2>{props.message}</h2>}
        {props.submessage && <p>{props.submessage}</p>}
      </div>
    </div>
  ) : (
    <div />
  )

export default OnboardingSpinner
